/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { SystemVarsRestService } from '@gh/builder-shared-data';
import { DictionaryService, globalDictionaries, InitViewService } from '@gh/common-shared';

@Injectable()
export class SystemVarsMasterZoneTabBusinessService implements InitViewService {
  constructor(private restService: SystemVarsRestService,
              private userContext: BuilderUserContext,
              private dictionaryService: DictionaryService) {

  }

  initView(): any {
    return {
      states: this.dictionaryService.get(globalDictionaries.states),
      masterZone: this.restService.getMasterZoneInfo(),
    };
  }
}
